// extracted by mini-css-extract-plugin
export default {"textarea":"teacher-bio-setting_textarea__gSTal"};